import OpponentsDetails from './OpponentsDetails';

export default OpponentsDetails;
